import React from 'react';
import {useState} from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';

function ModalPackageWarning(props) {
    const navigate = useNavigate();

    const redirectPage = (item) => {
        navigate(`${item.url}?bankId=${item.bank_id}&type=${item.type}`);
    };

    return (
        <Modal
            {...props}
            backdrop="static"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title>Thông báo</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className="text-danger">Tài khoản / gói Bill bên dưới của bạn đã hết hạn, Vui lòng gia hạn để tiếp tục sử dụng !</span>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Tài khoản / Gói</th>
                      <th>Ngày hết hạn</th>
                      <th>Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    {props.packageExpired.map((item, key) => (
                      <tr key={key}>
                        <td dangerouslySetInnerHTML={{__html: item.name}}></td>
                        <td>{item.expired_date}</td>
                        <td className="text-center">
                          <button 
                            className="btn btn-primary btn-sm"
                            onClick={() => redirectPage(item)}
                          >
                            Gia hạn
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={props.onHide}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalPackageWarning;